import { Injectable } from "@angular/core";
import { ExtractSenderDetailPipe } from "app/pipes/documents-right-sidebar-pipes/extract-sender-details.pipe";
import { Observable, Subject } from "rxjs";
import { IDocumentSectionable } from "../../contract-control/contract-control.dto";
import { IDocumentDetailRootDTO } from "../dto/document-details.dto";


export interface IUpdateMetaDataParam {
  uuid: string[];
  deleted_field_uuid?: string[];
}

@Injectable({
  providedIn: 'root'
})




export class DocumentHelperFacade {

  protected _shouldUpdateFieldsData$: Subject<IUpdateMetaDataParam> = new Subject<IUpdateMetaDataParam>();

  constructor(private _extractSenderDetails$: ExtractSenderDetailPipe) { }



  /**
   * Redirects the user to a full-screen view based on the provided document data.
   * Constructs a URL using the sender's ID and the recipient's unique ID, then opens a new window with that URL.
   * Logs an error if the sender role or recipient role detail is undefined.
   *
   * @param documentData - The document data containing details about the sender and recipient.
   * @param roles_key - The key used to extract the sender details from the document data. Defaults to 'template_roles'.
   */
  redirectToFullScreen(documentData: IDocumentDetailRootDTO | IDocumentSectionable, roles_key: string = 'template_roles'): void {
    if(!documentData || !documentData?.[roles_key]){
      return;
    }
    const senderRole = this._extractSenderDetails$.transform(documentData[roles_key]);
    if (senderRole && senderRole.recipient_role_detail) {
      const { id } = senderRole;
      const { unique_id } = senderRole.recipient_role_detail;
      const url = `/#/sender/${id}/${unique_id}`;
      this.openWindow(url);
    } else {
      console.warn('Sender role or recipient role detail is undefined.');
    }
  }




  /**
   * Opens a new browser window or tab with the specified URL.
   *
   * @param url - The URL to be opened in the new window or tab.
   */
  openWindow(url: string): void {
    window.open(url, '_blank');
  }





  /**
   * Emits a signal to update the fields data.
   */
  emitShouldUpdateFieldsData(params: IUpdateMetaDataParam): void {
    this._shouldUpdateFieldsData$.next(params);
  }




  /**
   * Subscribes to the signal to update the fields data.
   */
  subscribeToShouldUpdateFieldsData(): Observable<IUpdateMetaDataParam> {
    return this._shouldUpdateFieldsData$.asObservable();
  }
}